"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.B2BAuthPanelIdle = exports.B2BAuthPanel = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_b2b_1 = require("@hotelplan/components.common.b2b");
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const components_common_lazy_render_1 = require("@hotelplan/components.common.lazy-render");
const components_common_modals_1 = require("@hotelplan/components.common.modals");
const graphql_local_types_1 = require("@hotelplan/graphql.local-types");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const AuthFormOverlay_1 = __importDefault(require("./AuthFormOverlay"));
const B2BLoginForm_1 = __importDefault(require("./B2BLoginForm"));
const B2BAuthPanelContent = styled_components_1.default.div.attrs({
    'data-id': `b2b-auth`,
})(({ theme }) => theme.auth.panelContent);
const B2BLoginFormOverlay = (0, styled_components_1.default)(components_common_modals_1.WhiteBoxModal).attrs({
    title: '',
    name: 'b2bLoginFormOverlay',
})(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    '.modal-wrapper': theme.auth.formModalWrapperStyles,
}), ({ theme }) => theme.modals.content);
const LogoutButton = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    testId: `logout`,
})(({ theme: { space, fontSizes } }) => ({
    marginRight: space[2],
    paddingLeft: space[3],
    paddingRight: space[3],
    fontSize: fontSizes[1],
}));
const B2BAuthPanel = props => {
    const [t] = (0, next_i18next_1.useTranslation)('auth');
    const { authB2BOverlay, channelType, close, login, logout } = props;
    const logoutHandler = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        yield logout();
        window.location.reload();
    }), [logout]);
    if (authB2BOverlay)
        return (react_1.default.createElement(B2BLoginFormOverlay, { show: authB2BOverlay, onClose: close },
            react_1.default.createElement(AuthFormOverlay_1.default, { title: t('auth:b2b.overlay.title') },
                react_1.default.createElement(B2BLoginForm_1.default, { onLogin: login, hasForgotPasswordLink: false }))));
    if (channelType !== graphql_local_types_1.AuthChannelType.B2B)
        return null;
    return (react_1.default.createElement(B2BAuthPanelContent, null,
        react_1.default.createElement(LogoutButton, { onClick: logoutHandler }, t('auth:b2b.logout')),
        react_1.default.createElement(components_common_b2b_1.B2BMarkupForm, null)));
};
exports.B2BAuthPanel = B2BAuthPanel;
const B2BAuthPanelIdle = props => {
    return (react_1.default.createElement(components_common_lazy_render_1.LazyHydrate, { whenIdle: true },
        react_1.default.createElement(exports.B2BAuthPanel, Object.assign({}, props))));
};
exports.B2BAuthPanelIdle = B2BAuthPanelIdle;
//# sourceMappingURL=B2BAuthPanel.js.map